// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"d2b0ef10","416":"6b0eb1f7","480":"ffe6f194","787":"057a11fe","791":"f1447960","801":"5d68ff8d","934":"3a2a469e"}[chunkId] + ".chunk.js";
};